import moment from 'moment';

export const ZIP_NAME = `documents-${moment().format(
  'YYYY-MM-DD HH:mm:ss',
)}.zip`;
